// cspell:disable
const QATags = Object.freeze({
  HLI: 'human_logo_icon',
  HHI: 'header_help_icon',
  HSI: 'header_search_icon',
  HSET: 'header_search_edit_text',
  HSATHBL: 'header_search_autocomplete_top_hit_backstage_link',
  HSATPCSL: 'header_search_autocomplete_top_hit_create_station_link',
  HSAABL: 'header_search_autocomplete_artist_backstage_link',
  HSACSL: 'header_search_autocomplete_artist_create_station_link',
  HSATBL: 'header_search_autocomplete_track_backstage_link',
  HSATCSL: 'header_search_autocomplete_track_create_station_link',
  HNPL: 'header_now_playing_link',
  HMSL: 'header_my_stations_link',
  HT: 'header_title_text',
  NPSLS: 'now_playing_station_list_station',
  NPSLRS: 'now_playing_station_list_recommended_station',
  SHT: 'sub_header_text',
  STI: 'station_tile_image',
  SNL: 'station_name_link',
  SLS: 'station_listen_status',
  ASTI: 'add_station_tile_image',
  ASPI: 'add_station_plus_icon',
  ASL: 'add_station_link',
  BGB: 'browse_genres_button',
  BPB: 'browse_podcasts_button',
  BB: 'browse_button',
  GCTI: 'genre_category_tile_image',
  GCNL: 'genre_category_name_link',
  GSC: 'genre_stations_count',
  GSTI: 'genre_station_tile_image',
  GSNL: 'genre_station_name_link',
  GSLC: 'genre_station_listeners_count',
  HVSB: 'hover_view_stations_button',
  ASPEO: 'active_station_playing_equalizer_overlay',
  ASPSEO: 'active_station_paused_equalizer_overlay',
  HPSB: 'hover_play_station_button',
  HOMSB: 'hover_open_menu_station_button',
  HMPSB: 'hover_menu_play_station_button',
  HMPB: 'hover_menu_pause_button',
  HMDB: 'hover_menu_delete_button',
  HPI: 'header_pandora_image',
  HPOI: 'header_pandoraone_image',
  HPRI: 'header_profile_image',
  PMPM: 'profile_myprofile_menu',
  PFM: 'profile_feed_menu',
  PSM: 'profile_settings_menu',
  PHM: 'profile_help_menu',
  PCM: 'profile_community_menu',
  PSOM: 'profile_signout_menu',
  SAI: 'station_active_image',
  SAID: 'station_active_image_default',
  SAN: 'station_active_name',
  SAE: 'station_active_equalizer',
  SI: 'station_image',
  SID: 'station_image_default',
  SNLI: 'station_name_listener',
  SNR: 'station_name_recomended',
  SEA: 'station_see_all',
  AAI: 'album_active_image',
  AAID: 'album_active_image_default',
  AHI: 'album_history_image',
  AHID: 'album_history_image_default',
  PTT: 'playing_track_title',
  PAN: 'playing_artist_name',
  PALN: 'playing_album_name',
  SIMAIT: 'similar_artist_item',
  SIMAI: 'similar_artist_image',
  SIMAN: 'similar_artist_name',
  HAEI: 'history_active_equalizer_image',
  HATU: 'history_active_thumbs_up',
  HATD: 'history_active_thumbs_down',
  HIM: 'history_infocus_image',
  HIMD: 'history_infocus_image_default',
  HIFTU: 'history_infocus_thumbs_up',
  HIFTD: 'history_infocus_thumbs_down',
  HIFR: 'history_infocus_replay',
  HTT: 'history_track_title',
  HAA: 'history_artist_name',
  HIMG: 'history_image',
  HIMGD: 'history_image_default',
  HTU: 'history_thumbs_up',
  HTD: 'history_thumbs_down',
  MTI: 'mini_track_image',
  MTT: 'mini_track_title',
  MTAN: 'mini_track_artist_name',
  TDB: 'thumbs_down_button',
  RB: 'replay_button',
  PLAYPAUSE: ['play_button', 'pause_button'],
  SB: 'skip_button',
  TUB: 'thumbs_up_button',
  ET: 'elapsed_time',
  RT: 'remaining_time',
  VI: 'volume_icon',
  VS: 'volume_slider',
  VSH: 'volume_slider_handle',
  PI: 'password_input',
  PSL: 'password_show_link',
  BI: 'birthyear_input',
  BYL: 'birthyear_why_link',
  ZI: 'zipcode_input',
  ZYL: 'zipcode_why_link',
  GFB: 'gender_female_button',
  GFS: 'gender_female_span',
  GMB: 'gender_male_button',
  GMS: 'gender_male_span',
  GNB: 'gender_non_binary_button',
  GYL: 'gender_why_link',
  SUB: 'signup_button',
  KMLB: 'keepme_loggedin_button',
  HSB: 'header_signup_button',
  HLB: 'header_login_button',
  ECB: 'email_clear_button',
  EI: 'email_input',
  LB: 'login_button',
  PT: 'popup_title',
  PST: 'popup_sub_title',
  PM: 'popup_message',
  CPXB: 'close_popup_x_button',
  URSB: 'undo_remove_station_button',
  CB: 'cancel_button',
  SUBB: 'submit_button',
  DAB: 'delete_account_button',
  KAB: 'keep_account_button',
  OB: 'ok_button',
  LOADB: 'log_out_all_devices_button',
  CLOADB: 'cancel_log_out_all_devices_button',
  GTCSB: 'go_to_classic_site_button',
  KLB: 'keep_listening_button',
  YB: 'yes_button',
  NNB: 'not_now_button',
  NB: 'no_button',
  RMB: 'read_more_button',
  CLB: 'close_button',
  COB: 'continue_button',
  YPL: 'your_profile_link',
  TUL: 'thumbs_up_link',
  PN: 'profile_name',
  PPS: 'profile_privacy_status',
  PEL: 'profile_edit_link',
  PB: 'profile_bio',
  PEN: 'profile_edit_name',
  PESL: 'profile_edit_settings_link',
  PELO: 'profile_edit_location',
  PEE: 'profile_edit_employer',
  PES: 'profile_edit_school',
  PEB: 'profile_edit_bio',
  PECB: 'profile_edit_cancel_button',
  PESB: 'profile_edit_save_button',
  TTI: 'track_thumbnail_image',
  TNL: 'track_name_link',
  TANL: 'track_artist_name_link',
  TSNL: 'track_station_name_link',
  TOMB: 'track_open_menu_button',
  TMCS: 'track_menu_create_station',
  ARTI: 'artist_thumbnail_image',
  ARNL: 'artist_name_link',
  AROMB: 'artist_open_menu_button',
  ARMCS: 'artist_menu_create_station',
  ATI: 'album_thumbnail_image',
  ANL: 'album_name_link',
  AANL: 'album_artist_name_link',
  AOMB: 'album_open_menu_button',
  MCTT: 'mini_coachmark_title_text',
  MCMT: 'mini_coachmark_message_text',
  MCCB: 'mini_coachmark_close_button',
  MCBB: 'mini_coachmark_browse_button',
  PUMI: 'popup_main_image',
  PUTT: 'popup_title_text',
  PUMT: 'popup_message_text',
  PULMLB: 'popup_let_me_listen_button',
  PULTLB: 'popup_let_them_listen_button',
  AAN: 'aam_artist_name',
  ACB: 'aam_cta_button',
  VAN: 'vt_artist_name',
  VCB: 'vt_cta_button',
  AIFI: 'aam_inappropriate_flag_icon',
  AHAN: 'aam_history_artist_name',
  AHCB: 'aam_history_cta_button',
  VHAN: 'vt_history_artist_name',
  VHCB: 'vt_history_cta_button',
  AHIFI: 'aam_history_inappropriate_flag_icon',
  WAB: 'why_ads_button',
  DD: 'dropdown',
  HSTT: 'header_static_text_title',
  HSTST: 'header_static_text_subtitle',
  HSTSTL: 'header_static_text_subtitle_link',
  BT: 'bio_title',
  BTX: 'bio_text',
  BSMB: 'bio_show_more_button',
  BS: 'backstage',
  BGSMB: 'backstage_grid_show_more_button',
  BGSME: 'backstage_grid_show_more_ellipsis',
  BGI: 'backstage_grid_item',
  BGIA: 'backstage_grid_item_art',
  BPRG: 'backstage_playable_row_grid',
  BGITF: 'backstage_grid_item_text_first',
  BGITS: 'backstage_grid_item_text_second',
  BGITT: 'backstage_grid_item_text_third',
  BGIIL: 'backstage_grid_item_itunes_logo',
  BSTL: 'backstage_twitter_link',
  BST: 'backstage_tracks',
  BAT: 'backstage_album_track',
  BSET: 'backstage_editable_title',
  BSPA: 'backstage_playlist_author',
  BSPTC: 'backstage_playlist_track_count',
  BATEQ: 'backstage_album_track_eq',
  BATI: 'backstage_album_track_itunes',
  BATL: 'backstage_album_track_link',
  BTAL: 'backstage_track_artist_link',
  BTLL: 'backstage_track_album_link',
  LSMB: 'lyrics_show_more_button',
  LSLB: 'lyrics_show_less_button',
  MLIIL: 'media_list_item_itunes_logo',
  SP: 'sample_player',
  RPA: 'radial_progress_animation',
  FT: 'focus_traits',
  S: 'search',
  SFP: 'search_field_placeholder',
  SFC: 'search_field_clear',
  SLITFL: 'search_list_item_text_first_line',
  ASI: 'autocomplete_search_input',
  AMSL: 'autocomplete_menu_section_link',
  SRT: 'search_results_title',
  SRLI: 'search_results_list_item',
  MCDC: 'modal_coachmark_dialog_close',
  MCDCTA: 'modal_coachmark_dialog_cta',
  CCNAME: 'creditcardform_name',
  CCNUMBER: 'creditcardform_number',
  CCEXPMONTH: 'creditcardform_expiration_month',
  CCEXPYEAR: 'creditcardform_expiration_year',
  CCSECURITYCODE: 'creditcardform_security_code',
  CCZIPCODE: 'creditcardform_zipcode',
  PSCA: 'payment_submit_checkbox_agreeToTerms',
  PSSTL: 'payment_submit_subscription_terms_link',
  PSSOTL: 'payment_submit_subscription_offer_terms_link',
  PSB: 'paypal_submit_button',
  CCSUBMIT: 'creditcardform_submit',
  PSCCTB: 'payment_submit_credit_card_toggle_button',
  PSPTB: 'payment_submit_paypal_toggle_button',
  PSMFORB: 'payment_submit_monthly_frequency_option_radio_button',
  PSYFORB: 'payment_submit_yearly_frequency_option_radio_button',
  PSSRAR: 'payment_subscription_student_reverification_auto_renew',
  PSSRRNW: 'payment_subscription_student_reverification_renewal',
  MONTHLYPLAN: 'monthly_plan',
  YEARLYPLAN: 'yearly_plan',
  TIERSETTINGS: 'tier_settings',
  SPLINK: 'switch_plans_link',
  SPMONTHLY: 'switch_plans_monthly',
  SPANNUAL: 'switch_plans_annual',
  SPSWITCH: 'switch_plans_switch',
  SPCONTINUE: 'switch_plans_continue',
  SPCANCEL: 'switch_plans_cancel',
  MB: 'message_bar',
  CANCELP: 'cancel_password',
  DAC1: 'display_ad_container_1',
  DAC2: 'display_ad_container_2',
  SCAC: 'source_card_add_collection',
  SCRC: 'source_card_remove_collection',
  SCRP: 'source_card_remove_track_from_playlist',
  SCAP: 'source_card_add_playlist',
  SCNP: 'source_card_new_playlist',
  SCDP: 'source_card_delete_playlist',
  SCSST: 'source_card_start_station_track',
  SCSSA: 'source_card_start_station_artist',
  SCDS: 'source_card_delete_station',
  SCTOT: 'source_card_tired_of_track',
  SCS: 'source_card_share',
  SCES: 'source_card_edit_station',
  SCWTS: 'source_card_why_this_song',
  TB: 'tuner_bar',
  NPT3RT: 'now_playing_t3_row_item_text',
  NPT3RP: 'now_playing_t3_row_item_play_button',
  NPT3CT: 'now_playing_t3_current_track',
  T3SFB: 't3_skip_forward_button',
  T3SBB: 't3_skip_back_button',
  RI: 'row_item',
  MCALL: 'my_collection_all_link',
  MCALB: 'my_collection_albums_link',
  MCART: 'my_collection_artists_link',
  MCSONG: 'my_collection_songs_link',
  MCST: 'my_collection_stations_link',
  MCPL: 'my_collection_playlists_link',
  MCPC: 'my_collection_podcasts_link',
  MCPE: 'my_collection_episodes_link',
  MCEMPTY: 'my_collection_empty_state',
  MCNPB: 'my_collection_new_playlist_button',
  MCSDD: 'my_collection_sort_dropdown',
  MCALPHAO: 'my_collection_alpha_option',
  MCRAO: 'my_collection_recent_added_option',
  BRP: 'button_row_play',
  BRAMC: 'button_row_add_to_my_collection',
  BRRMC: 'button_row_remove_from_my_collection',
  BRCS: 'button_row_create_station',
  BRDS: 'button_row_delete_station',
  BRDP: 'button_row_delete_playlist',
  BRPU: 'button_row_pause',
  BRELL: 'button_row_ellipsis',
  BRSC: 'button_row_sourcecard',
  BRS: 'button_row_share',
  BPIP: 'backstage_playable_item_play',
  BPI: 'backstage_playable_item',
  SMBMT: 'share_modal_body_main_text',
  SMBRMT: 'share_modal_btm_row_main_text',
  SMHE: 'share_modal_header_email',
  SMSBF: 'share_modal_social_button_facebook',
  SMSBT: 'share_modal_social_button_twitter',
  SMSB: 'share_modal_share_button',
  HMSB: 'hover_menu_share_button',
  HMSD: 'hover_menu_station_details',
  TRB: 'tuner_repeat_button',
  TSB: 'tuner_shuffle_button',
  BSH: 'backstage_header',
  BSAB: 'backstage_artist_buttons',
  BSATS: 'backstage_artist_top_songs',
  BSASS: 'backstage_artist_start_station',
  BSATM: 'backstage_artist_top_songs_mobile_web',
  DBL: 'description_backstage_link',
  DBT: 'description_backstage_text',
  SRB: 'settings_redeem_button',
  SHQA: 'settings_high_quality_audio',
  DTMSC: 'discovery_tuner_mode_selection_column',
  DTIT: 'discovery_tuner_introduction_text',
  DTMBL: 'discovery_tuner_mode_buttons_list',
  DTMB: 'discovery_tuner_mode_button',
  DTMBN: 'discovery_tuner_mode_button_name',
  // todo: WEBCLIENT-7380: technical decision on whether to modularize QATags
  // Modals
  MDPC: 'modal_delete_playlist_confirm',
  // Footer.jsx
  F: 'footer',
  SUM: 'footer_signup_message',
  SUCTA: 'footer_signup_cta_button',
  // InfoCardC.jsx
  ICC: 'info_card_chevron',
  // UpgradeSplashDevice.jsx
  USDI: 'upgrade_splash_device_image',
  USDC: 'upgrade_splash_device_cta',
  // UpgradeLayout.jsx
  ULH: 'upgrade_layout_header',
  ULS: 'upgrade_layout_subheader',
  ULTOTL: 'upgrade_layout_trial_offer_terms_link', // trial offer terms link
  // UpgradeCard.jsx
  UC: 'upgrade_card', // (variation will be appended)
  UCPT: 'upgrade_card_product_text', // primary text
  UCST: 'upgrade_card_pricing_text', // secondary text
  UCC: 'upgrade_card_cta_button', // cta
  UCCL: 'upgrade_card_content_list',
  UCCLPFML: 'upgrade_card_content_list_premium_features_modal_link',
  UCFT: 'upgrade_card_footer_text', // footer text
  UCPLT: 'upgrade_card_links_title', // pipedLinks title
  UCPLL: 'upgrade_card_link', // pipedLinks link (variation will be appended)
  // AuthLayout.jsx
  AL: 'auth_layout', // (page variation will be appended)
  /* QA tags for Skips/Replays coachmarks, which are hosted in haymaker:
   *   'coachmark_main_image',
   *   'coachmark_title_text',
   *   'coachmark_message_text',
   *   'coachmark_get_skips_button',
   *   'coachmark_get_replays_button',
   *   'coachmark_not_now_button'
   */
});

export default QATags;
